module.exports = __webpack_public_path__ + "static/img/signature.33d1785.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cert/signature.png
// module id = gm3i
// module chunks = 126